// main.ts
import { initPreferences } from '@vben/preferences';
import { unmountGlobalLoading } from '@vben/utils';
import { loadConfig } from '#/config';
import { setupVersionGuard } from '#/utils/version-guard';
import { overridesPreferences } from './preferences';
import '#/assets/font/iconfont.css'; // 项目样式
import '#/assets/css/block.scss';
import '#/utils/icons';
import { addCollection } from '@iconify/vue';

import carbonIcons from '#/assets/icons/carbon.json' assert { type: 'json' };
import lucideIcons from '#/assets/icons/lucide.json' assert { type: 'json' };

// 注册本地图标
addCollection(carbonIcons);
addCollection(lucideIcons);
/**
 * 应用初始化完成之后再进行页面加载渲染
 */
async function initApplication() {
  setupVersionGuard();
  await loadConfig();
  // name用于指定项目唯一标识
  // 用于区分不同项目的偏好设置以及存储数据的key前缀以及其他一些需要隔离的数据
  const env = import.meta.env.PROD ? 'prod' : 'dev';
  const appVersion = import.meta.env.VITE_APP_VERSION;
  const namespace = `${import.meta.env.VITE_APP_NAMESPACE}-${appVersion}-${env}`;

  // app偏好设置初始化
  await initPreferences({
    namespace,
    overrides: overridesPreferences,
  });

  // 启动应用并挂载
  // vue应用主要逻辑及视图
  const { bootstrap } = await import('./bootstrap');
  await bootstrap(namespace);

  // 移除并销毁loading
  unmountGlobalLoading();
}

initApplication();
